<template>
  <div style="padding: 20px">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addOrderExpress">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
          :data-source="table.data"
          style="width: 100%">
        <a-table-column
            data-index="expressNo"
            :title="$t('EXPRESS_NO')">
        </a-table-column>
        <a-table-column
            data-index="status"
            :title="$t('EXPRESS_STATUS')">
          <template slot-scope="text,record">
            {{ $t(record.status) }}
          </template>
        </a-table-column>
        <a-table-column
            data-index="date"
            :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editOrderExpress(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="deleteOrderExpress(record.id)"> {{ $t('DELETE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
        :footer="null"
        title="提示"
        append-to-body
        v-model="form.visible">
      <website-order-express-edit
          v-if="form.visible"
          :order-id="orderId"
          :order-express-id="form.data.id"
          :on-cancel-handler="closeForm"
          :on-submit-handler="onSubmitHandler">
      </website-order-express-edit>
    </a-modal>
  </div>
</template>

<script>
import {
  _deleteWebsiteOrderExpress,
  _queryWebsiteOrderExpressByOrderId,
  _queryAllWebsiteOrderExpress
} from '@/api/websiteOrderExpressApi';
import WebsiteOrderExpressEdit from '@/views/website/orderExpress/WebsiteOrderExpressEdit.vue';

async function getOrderExpressList() {
  if (this.orderId) {
    this.table.data = await _queryAllWebsiteOrderExpress(this.orderId);
  }
}

function addOrderExpress() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editOrderExpress(orderExpressId) {
  this.form.data.id = orderExpressId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getOrderExpressList();
}

async function deleteOrderExpress(orderExpressId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteWebsiteOrderExpress(orderExpressId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.getOrderExpressList();
    },
  });
}

export default {
  name: 'WebsiteOrderExpressList',
  components: { WebsiteOrderExpressEdit },
  props: {
    orderId: String,
    onSubmitHandler: Function,
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getOrderExpressList,
    deleteOrderExpress,
    editOrderExpress,
    addOrderExpress,
    closeForm,
  },
  created() {
    this.getOrderExpressList();
  },
};
</script>

<style scoped>

</style>
